var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgentCircleCi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-Circle-CI-18x18",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.000000)",
    fill: "#0A0B09"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.78589474,6.88476316 C9.97910526,6.88476316 10.9463684,7.85202632 10.9463684,9.04523684 C10.9463684,10.2384474 9.97910526,11.2057105 8.78589474,11.2057105 C7.59268421,11.2057105 6.62542105,10.2384474 6.62542105,9.04523684 C6.62542105,7.85202632 7.59268421,6.88476316 8.78589474,6.88476316",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78589474,-3.36572875e-15 C4.58028947,-3.36572875e-15 1.03713158,2.88071053 0.0288947368,6.76942105 C0.0288947368,6.79831579 3.36572875e-15,6.82697368 3.36572875e-15,6.88476316 C3.36572875e-15,7.11521053 0.201552632,7.31676316 0.432,7.31676316 L4.0905,7.31676316 C4.26339474,7.31676316 4.40739474,7.20165789 4.49384211,7.05742105 C4.49384211,7.05742105 4.49384211,7.05742105 4.49384211,7.02876316 C5.24273684,5.41563158 6.88476316,4.29205263 8.78589474,4.29205263 C11.4072632,4.29205263 13.5101842,6.42386842 13.5101842,9.01634211 C13.5101842,11.6088158 11.3783684,13.7406316 8.78589474,13.7406316 C6.88476316,13.7406316 5.24273684,12.6170526 4.49384211,11.0039211 L4.49384211,10.9752632 C4.43605263,10.8310263 4.26339474,10.7159211 4.0905,10.7159211 L0.432,10.7159211 C0.201552632,10.7159211 3.36572875e-15,10.9174737 3.36572875e-15,11.1479211 C3.36572875e-15,11.1768158 3.36572875e-15,11.2343684 0.0288947368,11.2632632 C1.03713158,15.1519737 4.58028947,18.0326842 8.78589474,18.0326842 C13.7692895,18.0326842 17.8311316,13.9997368 17.8311316,8.98744737 C17.8311316,3.97515789 13.7981842,-3.36572875e-15 8.78589474,-3.36572875e-15 L8.78589474,-3.36572875e-15 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentCircleCi);
export default __webpack_public_path__ + "static/media/agent-circle-ci.5ea31078a5304fb8ca636a20d1c63aca.svg";
export { ForwardRef as ReactComponent };